import { render, staticRenderFns } from "./ElementOtherConfig.vue?vue&type=template&id=404e7cfd&"
import script from "./ElementOtherConfig.vue?vue&type=script&lang=js&"
export * from "./ElementOtherConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('404e7cfd')) {
      api.createRecord('404e7cfd', component.options)
    } else {
      api.reload('404e7cfd', component.options)
    }
    module.hot.accept("./ElementOtherConfig.vue?vue&type=template&id=404e7cfd&", function () {
      api.rerender('404e7cfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bpmnProcessDesigner/package/penal/other/ElementOtherConfig.vue"
export default component.exports